import {
    USERS_POST_REQUEST,
    USERS_POST_SUCCESS,
    USERS_POST_FAILURE,
} from 'actions';

const initialState = {
    posting: false,
    hasErrors: false,
};

export const userManagementPostReducer = (state = initialState, action) => {
    const { type } = action;
    switch (type) {
        case USERS_POST_SUCCESS: return { ...initialState };

        case USERS_POST_REQUEST: return { ...initialState, posting: true };

        case USERS_POST_FAILURE: return { ...initialState, hasErrors: true };

        default: return state;
    }
};
